// @ services
const Api = require('services/api');
// @ utilities
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const { FIRST_STEP, SECOND_STEP } = require('constants/RAConstants');
// @ actions
const preLoaderActions = require('./preLoaderActions');
import { getDateWithOffset, getDayStart } from 'utilities/dateHelper/dateHelper';

const resetStep = step => ({
    type: actionTypes.RA_SET_GOAL_RESET,
    payload: {
        step,
    },
});

const updateGoalSelected = goalSelected => ({
    type: actionTypes.RA_UPDATE_SELECTED_GOAL,
    payload: {
        goalSelected,
    },
});

const setInvestmentGoalValue = (key, value) => ({
    type: actionTypes.RA_SET_GOAL_SET_INVESTMENT_GOAL_VALUE,
    payload: {
        key,
        value,
    },
});

const setVisibleStep = step => ({
    type: actionTypes.RA_SET_GOAL_SET_VISIBLE_STEP,
    payload: {
        step,
    },
});

const validateUIStep = step => ({
    type: actionTypes.RA_SET_GOAL_VALIDATE_UI_STEP,
    payload: {
        step,
    },
});

const setFromSetGoal = () => ({
    type: actionTypes.RA_SET_FROM_SET_GOAL,
});

const saveGoalOnboardingRequest = () => ({
    type: actionTypes.RA_SAVE_GOAL_ONBOARDING_REQUEST,
});

const saveGoalOnboardingFailure = error => ({
    type: actionTypes.RA_SAVE_GOAL_ONBOARDING_FAILURE,
    payload: error,
});

const saveGoalOnboardingSuccess = () => ({
    type: actionTypes.RA_SAVE_GOAL_ONBOARDING_SUCCESS,
});

const getGoalOnboardingSuccess = data => ({
    type: actionTypes.RA_GET_GOAL_ONBOARDING_SUCCESS,
    payload: {
        objective: data.goalSelected.goalName,
        objectiveType: data.goalSelected.goalType,
        objectiveAmount: data.goalSelected.goalAmount,
        objectiveEndDate: data.goalSelected.goalDate,
    },
});

const getGoalOnboardingFailure = (error = '') => ({
    type: actionTypes.RA_GET_GOAL_ONBOARDING_FAILURE,
    payload: error,
});

const getGoalOnboardingRequest = () => ({
    type: actionTypes.RA_DELETE_GOAL_ONBOARDING_REQUEST,
});

const deleteGoalOnboardingSuccess = () => ({
    type: actionTypes.RA_DELETE_GOAL_ONBOARDING_SUCCESS,
});

const deleteGoalOnboardingFailure = (error = '') => ({
    type: actionTypes.RA_DELETE_GOAL_ONBOARDING_FAILURE,
    payload: error,
});

const deleteGoalOnboardingRequest = () => ({
    type: actionTypes.RA_DELETE_GOAL_ONBOARDING_REQUEST,
});

const updateCustomPlanByObjective = data => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_GOAL_ONBOARDING,
    payload: {
        objective: data.goalSelected.goalName,
        objectiveType: data.goalSelected.goalType,
        objectiveAmount: data.goalSelected.goalAmount,
        objectiveEndDate: data.goalSelected.goalDate || getDateWithOffset(getDayStart(), { days: 1, years: 1 }),
    },
});

const updateGoalFromSimulation = data => ({
    type: actionTypes.RA_UPDATE_GOAL_FROM_SIMULATION,
    payload: {
        objective: data.name,
        objectiveType: data.type,
        objectiveAmount: data.amount,
        objectiveEndDate: data.endDate,
    },
});

const getSimulation = () => (dispatch, getState) => {
    const immSimulation = getState().raSimulation.get('simulation');

    dispatch({
        type: actionTypes.RA_SET_GOAL_GET_DATA_FROM_SIMULATION,
        payload: immSimulation,
    });
};

const saveGoal = accessToken => (dispatch, getState) => {
    const simulation = getState().raSimulation.get('simulation').toJS();
    simulation.pureRobo = false;

    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: simulation,
    };

    dispatch({
        type: actionTypes.RA_SET_GOAL_REQUEST,
    });

    return Api.post(apiURLBuilder.getURL('raSimulation'), requestData)
        .then(() => {
            dispatch({
                type: actionTypes.RA_SET_GOAL_SUCCESS,
            });
        })
        .catch(error => {
            if (error.error) {
                dispatch({
                    type: actionTypes.RA_SET_GOAL_ERROR,
                });
            } else {
                throw error;
            }
        });
};

const saveGoalOnboardingService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('productsGoalsSelected'), requestData)
        .then(response => {
            if (response.body.status === 'OK') {
                dispatch(saveGoalOnboardingSuccess());
                if (callback) callback();
            } else {
                saveGoalOnboardingFailure();
            }
        })
        .catch(error => {
            if (error.error) {
                dispatch(saveGoalOnboardingFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

const saveGoalOnboarding = (accessToken, callback) => (dispatch, getState) => {
    const immCustomPlanByObjective = getState().raCustomPlanByObjective;

    const goalType = immCustomPlanByObjective.get('objectiveType');
    const goalName = immCustomPlanByObjective.get('objective');
    const goalAmount = immCustomPlanByObjective.get('objectiveAmount');
    const goalDate = immCustomPlanByObjective.get('objectiveEndDate').toString();

    const data = {
        goalType,
        goalName,
        goalAmount,
        goalDate,
    };

    dispatch(saveGoalOnboardingRequest());

    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: data,
    };

    saveGoalOnboardingService(dispatch, requestData, callback);
};

const getGoalOnboarding = accessToken => dispatch => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {},
    };

    dispatch(getGoalOnboardingRequest());

    return Api.get(apiURLBuilder.getURL('productsGoalsSelected'), requestData)
        .then(response => {
            if (response.body) {
                dispatch(getGoalOnboardingSuccess(response.body));
                dispatch(updateCustomPlanByObjective(response.body));
            } else {
                dispatch(getGoalOnboardingFailure());
            }
            dispatch(preLoaderActions.hidePreLoader());
        })
        .catch(error => {
            dispatch(preLoaderActions.hidePreLoader());
            if (error.error) {
                dispatch(getGoalOnboardingFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

const deleteGoalOnboarding = accessToken => dispatch => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {},
    };

    dispatch(deleteGoalOnboardingRequest());

    return Api.post(apiURLBuilder.getURL('productsGoalsSelectedDelete'), requestData)
        .then(response => {
            if (response.body.status === 'OK') {
                dispatch(deleteGoalOnboardingSuccess(response.body));
            } else {
                dispatch(deleteGoalOnboardingFailure());
            }
        })
        .catch(error => {
            if (error.error) {
                dispatch(deleteGoalOnboardingFailure(error.error.description));
            }
        });
};

const validateStep = step => (dispatch, getState) => {
    let valid;

    dispatch(validateUIStep(step));

    switch (step) {
        case FIRST_STEP:
            valid = getState().raSetGoal.getIn(['steps', FIRST_STEP, 'valid']);
            if (valid) {
                dispatch(setVisibleStep(step + 1));
            }
            break;
        case SECOND_STEP:
            valid = getState().raSetGoal.getIn(['steps', SECOND_STEP, 'valid']);
            if (valid) {
                dispatch(setVisibleStep(step + 1));
            }
            break;
        default:
            break;
    }
};

export default {
    getSimulation,
    resetStep,
    saveGoal,
    setFromSetGoal,
    setInvestmentGoalValue,
    setVisibleStep,
    updateGoalSelected,
    validateStep,
    saveGoalOnboarding,
    getGoalOnboarding,
    updateGoalFromSimulation,
    deleteGoalOnboarding,
};
